var _use, _symbol;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNativeBridge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 82 82",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#A",
    x: 0.5,
    y: 0.5
  })), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "A",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 17.76c0-3.546 3.037-6.4 6.809-6.4s6.808 2.854 6.808 6.4-3.037 6.4-6.808 6.4S32 21.306 32 17.76zm.511 44.48c0-3.546 3.037-6.4 6.809-6.4s6.809 2.854 6.809 6.4-3.037 6.4-6.809 6.4-6.809-2.855-6.809-6.4z",
    fill: "#7fba00",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.128 65.44h-3.234C8.511 65.44 0 57.44 0 47.68V32.16c.17-9.28 8.511-17.28 18.723-17.76h5.106c1.702 0 3.064 1.28 3.064 2.88s-1.362 2.88-3.064 2.88h-4.936c-6.808.32-12.596 5.6-12.596 11.84v15.52c0 6.56 5.617 11.84 12.596 11.84h3.234c1.702 0 3.064 1.28 3.064 2.88 0 1.92-1.362 3.2-3.064 3.2z",
    fill: "#59b4d9",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.106 65.44h-6.638c-1.702 0-3.064-1.28-3.064-2.88s1.362-2.88 3.064-2.88h6.638c6.979 0 12.596-5.28 12.596-11.84V32.32c0-6.56-5.617-11.84-12.596-11.84H56.17c-1.702 0-3.064-1.28-3.064-2.88s1.362-2.88 3.064-2.88h4.936c10.383 0 18.894 8 18.894 17.76V48c0 9.6-8.511 17.44-18.894 17.44z",
    fill: "#804998",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.468 35.52c-4.766 0-9.702-1.76-13.277-5.12a2.87 2.87 0 0 1 0-4.16c1.191-1.12 3.234-1.12 4.425 0 4.936 4.64 12.936 4.64 17.702 0 4.936-4.64 4.936-12.16 0-16.64-2.383-2.24-5.617-3.52-8.851-3.52-3.404 0-6.468 1.28-8.851 3.52-1.192 1.12-3.234 1.12-4.425 0a2.87 2.87 0 0 1 0-4.16A18.89 18.89 0 0 1 38.468 0c5.106 0 9.702 1.92 13.276 5.12a17.11 17.11 0 0 1 0 25.12c-3.575 3.52-8.34 5.28-13.276 5.28z",
    fill: "#68217a",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.149 80c-5.106 0-9.702-1.92-13.277-5.12a17.11 17.11 0 0 1 0-25.12c3.575-3.36 8.34-5.12 13.277-5.12 5.106 0 9.702 1.92 13.277 5.12a2.87 2.87 0 0 1 0 4.16c-1.191 1.12-3.234 1.12-4.425 0-2.383-2.24-5.617-3.52-8.851-3.52-3.404 0-6.468 1.28-8.851 3.52-4.936 4.64-4.936 12.16 0 16.64 2.383 2.24 5.447 3.52 8.851 3.52S45.617 72.8 48 70.56c1.191-1.12 3.234-1.12 4.426 0a2.87 2.87 0 0 1 0 4.16C49.021 78.08 44.255 80 39.149 80z",
    fill: "#0072c6",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNativeBridge);
export default __webpack_public_path__ + "static/media/nativeBridge.f413bef4bec2db05e4cdd8956c60d6c5.svg";
export { ForwardRef as ReactComponent };